import styled from '@emotion/styled';
import { Variables } from '../base/variables/variables';

interface IContainerProps {
    size?: 'small' | 'medium';
}

export const Container = styled.div<IContainerProps>`
    display: flex;
    align-items: center;
    gap: ${({ size }) => (size === 'small' ? '2px' : '4px')};
`;

interface INavigationButtonProps {
    size?: 'small' | 'medium';
}

export const NavigationButton = styled.button<INavigationButtonProps>`
    background: transparent;
    border: none;
    padding: ${({ size }) => (size === 'small' ? '4px' : '6px')};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${Variables.Rounded.small};
    color: ${Variables.Colors.n70};
    transition: ${Variables.transition};

    &:hover:not(:disabled) {
        background-color: ${Variables.Colors.n15_24};
    }

    &:active:not(:disabled) {
        background-color: ${Variables.Colors.n15_48};
    }

    &:disabled {
        cursor: default;
        color: ${Variables.Colors.n15};
    }
`;

interface ICounterTextProps {
    size?: 'small' | 'medium';
}

export const CounterText = styled.span<ICounterTextProps>`
    font-size: ${({ size }) => (size === 'small' ? '14px' : '16px')};
    color: ${Variables.Colors.n50};
    user-select: none;
    min-width: ${({ size }) => (size === 'small' ? '40px' : '50px')};
    text-align: center;
`;

